var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable prettier/prettier */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-useless-escape */
import { useEffect, useState } from "react";
import { Controller, FormProvider, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { zodResolver } from "@hookform/resolvers/zod";
import { Avatar, Box, Checkbox, FormControlLabel, MenuItem, Radio, RadioGroup, Stack, TextField, Typography } from "@mui/material";
import { ContainerForm } from "../../components/ContainerForm";
import { ContainerLayout } from "../../components/ContainerLayout";
import { FixedMenu } from "../../components/FixedMenu";
import { FormButton, FormButtonType } from "../../components/FormButton";
import AppBarHeader from "../../components/Home/AppBarHeader";
import { Loading } from "../../components/Loading";
import { Modal } from "../../components/Modal";
import { SnackbarFeedback } from "../../components/SnackbarFeedback";
import { useAuth } from "../../hooks/useAuth";
import { obterCidades, obterCursos } from "../../services/generico.service";
import { obterDadosCondutor, obterFoto, solicitarRenovacaoCnh, } from "../../services/habilitacao.service";
import { extrairCodigoArea, extrairNumero, formatName } from "../../util/formatadores";
import { formatarCpf } from "../../util/mascaras";
import { renovacaoCnhSchema } from "../../validators/habilitacaoSchema";
import { AlterarEndereco } from "./AlterarEndereco";
var tiposEnviosCarteira = [
    // {
    //   label: "Correios",
    //   valor: "C",
    // },
    {
        label: "Detran",
        valor: "D",
    },
];
var tiposFotoCondutor = [
    {
        label: "Reaproveitar foto atual",
        valor: "1",
    },
    {
        label: "Tirar nova foto no Detran",
        valor: "0",
    },
];
export var RenovacaoCnh = function () {
    var userInfo = useAuth().userInfo;
    var navigate = useNavigate();
    var _a = useState(), dados = _a[0], setDados = _a[1];
    var _b = useState(), errorMessage = _b[0], setErrorMessage = _b[1];
    var _c = useState(false), sucesso = _c[0], setSucesso = _c[1];
    var _d = useState(true), loading = _d[0], setLoading = _d[1];
    var _e = useState(""), cpf = _e[0], setCpf = _e[1];
    var _f = useState(null), photoSrc = _f[0], setPhotoScr = _f[1];
    var _g = useState(null), ciretrans = _g[0], setCiretrans = _g[1];
    var _h = useState(false), inputEnderecoAlterado = _h[0], setInputEnderecoAlterado = _h[1];
    var _j = useState(3), desejaRealizarCursos = _j[0], setDesejaRealizarCursos = _j[1];
    var _k = useState(false), modalCursos = _k[0], setModalCursos = _k[1];
    var _l = useState(false), modalCancelarCursos = _l[0], setModalCancelarCursos = _l[1];
    var _m = useState(false), loadingModal = _m[0], setLoadingModal = _m[1];
    var _o = useState(), cursosPossiveis = _o[0], setCursosPossiveis = _o[1];
    var _p = useState([]), idsCursosSelecionados = _p[0], setIdsCursosSelecionados = _p[1];
    var renovacaoCnhForm = useForm({
        resolver: zodResolver(renovacaoCnhSchema),
        defaultValues: {
            atividadeRemunerada: "",
            celSms: "",
            cpf: "",
            ddd: "",
            envioCarteira: "",
            fotoCondutor: "",
            juntaMedica: "",
            numeroRenach: "",
            idCiretran: "",
        },
    });
    var register = renovacaoCnhForm.register, handleSubmit = renovacaoCnhForm.handleSubmit, errors = renovacaoCnhForm.formState.errors, control = renovacaoCnhForm.control;
    var handleRegistrarSolicitacao = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var payload, error_1;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    setErrorMessage(undefined);
                    setLoading(true);
                    payload = {
                        cpf: data.cpf.replace(/[.\-]/g, ""),
                        ddd: data.ddd,
                        celSms: data.celSms,
                        numeroRenach: data.numeroRenach,
                        envioCarteira: data.envioCarteira,
                        fotoCondutor: data.fotoCondutor,
                        atividadeRemunerada: data.atividadeRemunerada,
                        juntaMedica: data.juntaMedica,
                        idCiretran: data.idCiretran,
                        listaObservacoes: idsCursosSelecionados ? idsCursosSelecionados.toString() : "",
                    };
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, solicitarRenovacaoCnh(payload)];
                case 2:
                    _d.sent();
                    setSucesso(true);
                    setTimeout(function () {
                        navigate("/home");
                    }, 1000);
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _d.sent();
                    setErrorMessage((_c = (_b = (_a = error_1 === null || error_1 === void 0 ? void 0 : error_1.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.MensagemRetorno) !== null && _c !== void 0 ? _c : "Erro ao solicitar renovação da CNH");
                    return [3 /*break*/, 5];
                case 4:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var verificarCiretransPorMunicipio = function (municipios) {
        if (dados === null || dados === void 0 ? void 0 : dados.idCidadePaisEndereco) {
            var cidades = municipios
                .filter(function (municipio) { return municipio.idCidadePais === (dados === null || dados === void 0 ? void 0 : dados.idCidadePaisEndereco); })
                .flatMap(function (item) { return item.ciretranMunicipio; });
            if (cidades.length !== 0) {
                return cidades;
            }
            else {
                return municipios.flatMap(function (municipio) { return municipio.ciretranMunicipio; });
            }
        }
        else {
            return municipios.flatMap(function (municipio) { return municipio.ciretranMunicipio; });
        }
    };
    var filtrarCursos = function (categoria, todosCursos, idsCursosVisiveis) {
        var idsCursosDisponiveis = [];
        var categorias = categoria.split("");
        for (var i = 0; i < categorias.length; i++) {
            switch (categorias[i]) {
                case "A":
                    var cursosA = idsCursosVisiveis.filter(function (id) { return ["04", "08", "09"].includes(id); });
                    idsCursosDisponiveis = idsCursosDisponiveis.concat(cursosA);
                    break;
                case "B":
                    var cursosB = idsCursosVisiveis.filter(function (id) { return ["01", "04"].includes(id); });
                    idsCursosDisponiveis = idsCursosDisponiveis.concat(cursosB);
                    break;
                case "C":
                    var cursosC = idsCursosVisiveis.filter(function (id) { return ["01", "04", "07"].includes(id); });
                    idsCursosDisponiveis = idsCursosDisponiveis.concat(cursosC);
                    break;
                case "D":
                    var cursosD = idsCursosVisiveis.filter(function (id) { return ["01", "02", "03", "04", "07"].includes(id); });
                    idsCursosDisponiveis = idsCursosDisponiveis.concat(cursosD);
                    break;
                case "E":
                    var cursosE = idsCursosVisiveis.filter(function (id) { return ["01", "02", "03", "04", "07"].includes(id); });
                    idsCursosDisponiveis = idsCursosDisponiveis.concat(cursosE);
                    break;
            }
        }
        idsCursosDisponiveis = idsCursosDisponiveis.filter(function (item, index) {
            return idsCursosDisponiveis.indexOf(item) === index;
        });
        var cursosPossiveis = todosCursos.filter(function (el) { return idsCursosDisponiveis.includes(el.chave); });
        setCursosPossiveis(cursosPossiveis);
    };
    var fetchCursos = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, idsTodosCursos, idsCursosOcultos_1, idsCursosVisiveis, error_2;
        var _a, _b, _c, _d, _e, _f;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0:
                    setErrorMessage(undefined);
                    if (!dados) return [3 /*break*/, 6];
                    _g.label = 1;
                case 1:
                    _g.trys.push([1, 3, 4, 5]);
                    setLoadingModal(true);
                    return [4 /*yield*/, obterCursos()];
                case 2:
                    response = _g.sent();
                    idsTodosCursos = response.map(function (curso) { return curso.chave; });
                    idsCursosOcultos_1 = (_c = (_b = (_a = dados.listaCursosCapacitacao) === null || _a === void 0 ? void 0 : _a.split(",")) === null || _b === void 0 ? void 0 : _b.map(function (el) { return el.trim(); })) !== null && _c !== void 0 ? _c : [];
                    idsCursosVisiveis = idsCursosOcultos_1 ? idsTodosCursos.filter(function (id) { return !idsCursosOcultos_1.includes(id); }).filter(function (el) { return !["05", "06"].includes(el); }) : idsTodosCursos;
                    filtrarCursos(dados.categoriaCnh, response, idsCursosVisiveis);
                    return [3 /*break*/, 5];
                case 3:
                    error_2 = _g.sent();
                    setModalCursos(false);
                    setErrorMessage((_f = (_e = (_d = error_2 === null || error_2 === void 0 ? void 0 : error_2.response) === null || _d === void 0 ? void 0 : _d.data) === null || _e === void 0 ? void 0 : _e.MensagemRetorno) !== null && _f !== void 0 ? _f : "Erro ao listar cursos de capacitação");
                    return [3 /*break*/, 5];
                case 4:
                    setLoadingModal(false);
                    return [7 /*endfinally*/];
                case 5: return [3 /*break*/, 7];
                case 6:
                    setErrorMessage("Erro ao recuperar informações do condutor");
                    _g.label = 7;
                case 7: return [2 /*return*/];
            }
        });
    }); };
    var changeCursos = function (idCurso) {
        setIdsCursosSelecionados(function (prevIds) {
            if (prevIds.includes(idCurso)) {
                return prevIds.filter(function (cursoId) { return cursoId !== idCurso; });
            }
            else {
                return __spreadArray(__spreadArray([], prevIds, true), [idCurso], false);
            }
        });
    };
    useEffect(function () {
        var fetchDados = function () { return __awaiter(void 0, void 0, void 0, function () {
            var payload, response, error_3;
            var _a, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _d.trys.push([0, 2, 3, 4]);
                        payload = {
                            cpf: userInfo === null || userInfo === void 0 ? void 0 : userInfo.preferred_username,
                        };
                        return [4 /*yield*/, obterDadosCondutor(payload)];
                    case 1:
                        response = _d.sent();
                        renovacaoCnhForm.reset({
                            cpf: formatarCpf(response.cpf),
                            ddd: extrairCodigoArea(response.telefone) || "",
                            celSms: extrairNumero(response.telefone) || "",
                            numeroRenach: response.numeroRenach,
                        });
                        setDados(response);
                        setCpf(response.cpf);
                        fetchFoto();
                        fetchCidades();
                        return [3 /*break*/, 4];
                    case 2:
                        error_3 = _d.sent();
                        setErrorMessage((_c = (_b = (_a = error_3 === null || error_3 === void 0 ? void 0 : error_3.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.MensagemRetorno) !== null && _c !== void 0 ? _c : "Erro ao recuperar dados da CNH");
                        console.error(error_3);
                        return [3 /*break*/, 4];
                    case 3:
                        setLoading(false);
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        var fetchFoto = function () { return __awaiter(void 0, void 0, void 0, function () {
            var payload, response, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(dados === null || dados === void 0 ? void 0 : dados.numeroRenach)) return [3 /*break*/, 5];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        payload = {
                            cpf: userInfo === null || userInfo === void 0 ? void 0 : userInfo.preferred_username,
                            numeroRenach: dados.numeroRenach,
                        };
                        return [4 /*yield*/, obterFoto(payload)];
                    case 2:
                        response = _a.sent();
                        setPhotoScr(response.fotoBase64);
                        return [3 /*break*/, 5];
                    case 3:
                        error_4 = _a.sent();
                        console.error(error_4);
                        return [3 /*break*/, 5];
                    case 4:
                        setLoading(false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        var fetchCidades = function () { return __awaiter(void 0, void 0, void 0, function () {
            var response, error_5;
            var _a, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (!(dados === null || dados === void 0 ? void 0 : dados.ufEmissao)) return [3 /*break*/, 4];
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, obterCidades(dados.ufEmissao)];
                    case 2:
                        response = _d.sent();
                        setCiretrans(verificarCiretransPorMunicipio(response));
                        return [3 /*break*/, 4];
                    case 3:
                        error_5 = _d.sent();
                        setErrorMessage((_c = (_b = (_a = error_5 === null || error_5 === void 0 ? void 0 : error_5.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.MensagemRetorno) !== null && _c !== void 0 ? _c : "Erro ao listar cidades");
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        fetchDados();
    }, [
        dados === null || dados === void 0 ? void 0 : dados.numeroRenach,
        renovacaoCnhForm,
        userInfo === null || userInfo === void 0 ? void 0 : userInfo.preferred_username,
        dados === null || dados === void 0 ? void 0 : dados.ufEmissao,
    ]);
    if (loading) {
        return (_jsxs(_Fragment, { children: [_jsx(AppBarHeader, { titulo: "Renova\u00E7\u00E3o de CNH", voltarPara: "/home" }), _jsx(Loading, {})] }));
    }
    return (_jsxs(_Fragment, { children: [_jsx(FixedMenu, { title: "Renova\u00E7\u00E3o de CNH", isHabilitacao: true }), _jsx(FormProvider, __assign({}, renovacaoCnhForm, { children: _jsx("form", __assign({ onSubmit: handleSubmit(handleRegistrarSolicitacao) }, { children: _jsx(Box, __assign({ mt: { xs: "17rem", md: "13rem" } }, { children: _jsxs(ContainerLayout, { children: [_jsxs(ContainerForm, __assign({ title: "Dados Pessoais" }, { children: [_jsx(TextField, __assign({ id: "cpf", label: "CPF", variant: "outlined", value: formatarCpf(cpf), InputLabelProps: {
                                                shrink: true,
                                            }, inputProps: {
                                                maxLength: 11,
                                            } }, register("cpf", {
                                            onChange: function (e) { return setCpf(formatarCpf(e.target.value)); },
                                        }), { error: errors.cpf !== undefined, helperText: errors.cpf && errors.cpf.message, disabled: true })), _jsxs(Stack, __assign({ direction: "row", gap: "0.5rem" }, { children: [_jsx(TextField, __assign({ id: "ddd", label: "DDD", variant: "outlined", InputLabelProps: {
                                                        shrink: true,
                                                    }, inputProps: {
                                                        maxLength: 2,
                                                        inputMode: "numeric",
                                                        pattern: "[0-9]*",
                                                    } }, register("ddd", {
                                                    onChange: function (e) {
                                                        var valorNumerico = e.target.value.replace(/\D/g, "");
                                                        e.target.value = valorNumerico;
                                                    },
                                                }), { error: errors.ddd !== undefined, helperText: errors.ddd && errors.ddd.message, sx: { width: "20%" } })), _jsx(TextField, __assign({ id: "celSms", label: "Celular", variant: "outlined", InputLabelProps: {
                                                        shrink: true,
                                                    }, inputProps: {
                                                        maxLength: 9,
                                                        inputMode: "numeric",
                                                        pattern: "[0-9]*",
                                                    } }, register("celSms", {
                                                    onChange: function (e) {
                                                        var valorNumerico = e.target.value.replace(/\D/g, "");
                                                        e.target.value = valorNumerico;
                                                    },
                                                }), { error: errors.celSms !== undefined, helperText: errors.celSms && errors.celSms.message, sx: { width: "90%" } }))] }))] })), _jsx(AlterarEndereco, { setInputAlterado: function (valor) { return setInputEnderecoAlterado(valor); } }), _jsxs(ContainerForm, __assign({ title: "Dados Gerais" }, { children: [_jsx(TextField, __assign({ id: "numeroRenach", label: "N\u00FAmero Renach", variant: "outlined", InputLabelProps: {
                                                shrink: true,
                                            }, inputProps: {
                                                maxLength: 11,
                                            } }, register("numeroRenach"), { error: errors.numeroRenach !== undefined, helperText: errors.numeroRenach && errors.numeroRenach.message, disabled: true })), _jsx(Controller, { name: "envioCarteira", control: control, defaultValue: "D", render: function (_a) {
                                                var _b = _a.field, onChange = _b.onChange, onBlur = _b.onBlur, value = _b.value, ref = _b.ref;
                                                return (_jsx(TextField, __assign({ select: true, id: "envioCarteira", label: "Envio da Carteira", variant: "outlined", InputLabelProps: {
                                                        shrink: true,
                                                    }, onChange: onChange, onBlur: onBlur, value: value, inputRef: ref, error: errors.envioCarteira !== undefined, helperText: errors.envioCarteira && errors.envioCarteira.message, disabled: true }, { children: tiposEnviosCarteira.map(function (tipo) { return (_jsx(MenuItem, __assign({ value: tipo.valor }, { children: tipo.label }), tipo.valor)); }) })));
                                            } }), _jsx(Controller, { name: "idCiretran", control: control, render: function (_a) {
                                                var _b = _a.field, onChange = _b.onChange, onBlur = _b.onBlur, value = _b.value, ref = _b.ref;
                                                return (_jsx(TextField, __assign({ select: true, id: "idCiretran", label: "Ciretran", variant: "outlined", InputLabelProps: {
                                                        shrink: true,
                                                    }, onChange: onChange, onBlur: onBlur, value: value, inputRef: ref, error: errors.idCiretran !== undefined, helperText: errors.idCiretran && 'A ciretran é obrigatório' }, { children: ciretrans === null || ciretrans === void 0 ? void 0 : ciretrans.map(function (ciretran) { return (_jsx(MenuItem, __assign({ value: ciretran === null || ciretran === void 0 ? void 0 : ciretran.idCiretran }, { children: ciretran === null || ciretran === void 0 ? void 0 : ciretran.nomeCiretran }), ciretran === null || ciretran === void 0 ? void 0 : ciretran.idCiretran)); }) })));
                                            } }), _jsxs(Stack, __assign({ direction: "row", alignItems: "center" }, { children: [photoSrc && (_jsx(Avatar, { src: "data:image/jpeg;base64,".concat(photoSrc), variant: "square", sx: { width: "8rem", height: "8rem" } })), _jsx(Controller, { name: "fotoCondutor", control: control, defaultValue: "0", render: function (_a) {
                                                        var _b = _a.field, onChange = _b.onChange, onBlur = _b.onBlur, value = _b.value, ref = _b.ref;
                                                        return (_jsx(TextField, __assign({ select: true, id: "fotoCondutor", label: "Deseja reaproveitar a foto atual ou solicitar uma nova foto?", variant: "outlined", InputLabelProps: {
                                                                shrink: true,
                                                            }, onChange: onChange, onBlur: onBlur, value: value, inputRef: ref, error: errors.fotoCondutor !== undefined, helperText: errors.fotoCondutor && errors.fotoCondutor.message, sx: { flexGrow: "1" }, disabled: !photoSrc }, { children: tiposFotoCondutor.map(function (tipo) { return (_jsx(MenuItem, __assign({ value: tipo.valor }, { children: tipo.label }), tipo.valor)); }) })));
                                                    } })] }))] })), _jsxs(ContainerForm, __assign({ title: "Atividade Remunerada?" }, { children: [_jsx(Controller, { name: "atividadeRemunerada", control: control, render: function (_a) {
                                                var _b = _a.field, onChange = _b.onChange, onBlur = _b.onBlur, value = _b.value;
                                                return (_jsxs(RadioGroup, __assign({ id: "atividadeRemunerada", onChange: onChange, onBlur: onBlur, value: value, "aria-labelledby": "atividade-remunerada-group-label", sx: { display: "flex", flexDirection: "row" } }, { children: [_jsx(FormControlLabel, { value: "0", control: _jsx(Radio, {}), label: "N\u00E3o" }), _jsx(FormControlLabel, { value: "1", control: _jsx(Radio, {}), label: "Sim" })] })));
                                            } }), errors.atividadeRemunerada && (_jsx(Typography, __assign({ variant: "body1", color: "error" }, { children: "Selecione se a atividade \u00E9 remunerada" })))] })), _jsxs(ContainerForm, __assign({ title: "Sua Carteira Nacional de Habilita\u00E7\u00E3o \u00E9 para uma pessoa com defici\u00EAncia  (Junta M\u00E9dica - PCD)?" }, { children: [_jsx(Controller, { name: "juntaMedica", control: control, render: function (_a) {
                                                var _b = _a.field, onChange = _b.onChange, onBlur = _b.onBlur, value = _b.value;
                                                return (_jsxs(RadioGroup, __assign({ "aria-labelledby": "junta-medica-group-label", id: "juntaMedica", onChange: onChange, onBlur: onBlur, value: value, sx: { display: "flex", flexDirection: "row" } }, { children: [_jsx(FormControlLabel, { value: "0", control: _jsx(Radio, {}), label: "N\u00E3o" }), _jsx(FormControlLabel, { value: "1", control: _jsx(Radio, {}), label: "Sim" })] })));
                                            } }), errors.juntaMedica && (_jsx(Typography, __assign({ variant: "body1", color: "error" }, { children: "Selecione se a CNH \u00E9 para uma pessoa com defici\u00EAncia" })))] })), _jsx(ContainerForm, __assign({ title: "Deseja realizar cursos de capacita\u00E7\u00E3o?" }, { children: _jsxs(RadioGroup, __assign({ "aria-labelledby": "junta-medica-group-label", id: "juntaMedica", sx: { display: "flex", flexDirection: "row" }, value: desejaRealizarCursos, onChange: function (e) { return setDesejaRealizarCursos(Number(e.target.value)); } }, { children: [_jsx(FormControlLabel, { value: 0, control: _jsx(Radio, {}), label: "N\u00E3o", onClick: function () { return setIdsCursosSelecionados([]); } }), _jsx(FormControlLabel, { value: 1, control: _jsx(Radio, {}), label: "Sim", onClick: function () {
                                                    fetchCursos();
                                                    setModalCursos(true);
                                                } })] })) })), _jsxs(Stack, __assign({ direction: { md: "row-reverse" }, marginY: "2rem", sx: { gap: "1rem" } }, { children: [_jsx(FormButton, { type: FormButtonType.PRIMARY, title: "Enviar", onClick: function () { return null; }, isSubmit: true, isDisabled: !inputEnderecoAlterado || desejaRealizarCursos === 3 }), _jsx(FormButton, { type: FormButtonType.SECONDARY, title: "Voltar", onClick: function () { return navigate("/home"); } })] }))] }) })) })) })), _jsx(Modal, __assign({ open: modalCursos, onClose: function () {
                    setModalCancelarCursos(true);
                    setModalCursos(false);
                }, title: "Cursos de Capacita\u00E7\u00E3o", subTitle: "Selecione os cursos de capacita\u00E7\u00E3o que voc\u00EA deseja realizar", directionButtons: "row-reverse", buttons: [
                    _jsx(FormButton, { type: FormButtonType.PRIMARY, title: "Confirmar", onClick: function () {
                            setModalCursos(false);
                        } }),
                    _jsx(FormButton, { type: FormButtonType.SECONDARY, title: "Cancelar", onClick: function () {
                            setModalCancelarCursos(true);
                            setModalCursos(false);
                        } }),
                ], isLoading: loadingModal }, { children: _jsx(Stack, __assign({ p: "1.5rem" }, { children: cursosPossiveis ? (cursosPossiveis.map(function (curso) { return (_jsx(FormControlLabel, { label: formatName(curso.descricao), control: _jsx(Checkbox, { checked: idsCursosSelecionados === null || idsCursosSelecionados === void 0 ? void 0 : idsCursosSelecionados.includes(curso.chave), onChange: function () { return changeCursos(curso.chave); }, name: curso.descricao }) }, curso.chave)); })) : (_jsx(Typography, __assign({ variant: "h6", textAlign: "center" }, { children: "Nenhum curso de capacita\u00E7\u00E3o dispon\u00EDvel." }))) })) })), _jsx(Modal, { open: modalCancelarCursos, onClose: function () {
                    setModalCancelarCursos(false);
                    setModalCursos(true);
                }, title: "Cancelar sele\u00E7\u00E3o de cursos de capacita\u00E7\u00E3o", subTitle: "Tem certeza que deseja cancelar a sele\u00E7\u00E3o dos cursos de capacita\u00E7\u00E3o?", directionButtons: "row-reverse", buttons: [
                    _jsx(FormButton, { type: FormButtonType.CANCEL_PRIMARY, title: "Sim", onClick: function () {
                            setIdsCursosSelecionados([]);
                            setDesejaRealizarCursos(0);
                            setModalCancelarCursos(false);
                        } }),
                    _jsx(FormButton, { type: FormButtonType.CANCEL_SECONDARY, title: "N\u00E3o", onClick: function () {
                            setModalCancelarCursos(false);
                            setModalCursos(true);
                        } }),
                ] }), sucesso && (_jsx(SnackbarFeedback, { isOpen: true, type: "success", message: "Solicita\u00E7\u00E3o realizada com sucesso" })), errorMessage && (_jsx(SnackbarFeedback, { isOpen: !!errorMessage, message: errorMessage, type: "error" }))] }));
};
